import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

@NgModule({
  exports: [ButtonModule, InputTextModule, InputTextareaModule],
})
export class PrimengModule {}
